import React from 'react';
import styled from 'styled-components';
import { DotWrapper } from "./Dot";
var SpinStyled = styled.div.withConfig({
  displayName: "Spin__SpinStyled",
  componentId: "sc-1n7h4hh-0"
})(["display:flex;position:relative;align-items:center;justify-content:center;"]);

var Spin = function Spin(_ref) {
  var show = _ref.show,
      children = _ref.children,
      color = _ref.color,
      _ref$loadingTestId = _ref.loadingTestId,
      loadingTestId = _ref$loadingTestId === void 0 ? 'spinner' : _ref$loadingTestId,
      loader = _ref.loader;

  if (!show) {
    return React.createElement(React.Fragment, null, children);
  }

  return React.createElement(SpinStyled, {
    "data-testid": loadingTestId
  }, children, React.createElement(DotWrapper, {
    color: color,
    loader: loader
  }));
};

export default Spin;